import { BaseDto } from './base.dto';
import { RecipeDto } from './recipe.dto';
import { StockLocationDto } from './stockLocation.dto';
import { StockWastageDto } from './stockWastage.dto';

export class RecipeWastageDetailDto extends BaseDto {
    stockWastage?: StockWastageDto;
    stockWastageId: number;
    recipe?: RecipeDto;
    recipeId: number;
    recipeLocation?: StockLocationDto;
    recipeLocationId: number;
    quantity: number;
    outOfStock: boolean;
    batchQty: number;
    portionQty: number;
    splitQty: number;
    totalValue: number;
    totalAMT: number;
}
